/**
 * Private things blur whenever the app isn't in front (TS-09): the phone's app switcher keeps a picture
 * of the last screen, and it shouldn't be someone's album or a chat. Whatever is marked `.fm-private`
 * blurs (tokens.css) while <html> has `fm-veiled`, and clears the moment the app is back.
 *
 * Hidden or put away: veiled. On a phone, losing focus too (the app switcher, the notification shade
 * or control center come down over the app); not on a computer, where clicking another window is
 * ordinary. An embedded frame taking focus isn't the app going away.
 */
export function watchVeil() {
  const root = document.documentElement
  const set = (on: boolean) => root.classList.toggle('fm-veiled', on)
  const shown = () => document.visibilityState === 'visible'
  document.addEventListener('visibilitychange', () => set(!shown()))
  window.addEventListener('pagehide', () => set(true))
  window.addEventListener('pageshow', () => set(!shown()))
  if (window.matchMedia('(pointer: coarse)').matches) {
    window.addEventListener('blur', () => {
      if (document.activeElement?.tagName !== 'IFRAME') set(true)
    })
    window.addEventListener('focus', () => set(false))
  }
}
